import React, { useState} from 'react'
import {Select, Box,Grid, TextField,Button,Card,Divider,useMediaQuery, Container,IconButton,OutlinedInput, FormHelperText,FormControl,InputLabel,InputAdornment,MenuItem } from '@mui/material';
import { Typography } from 'material-ui';
import { useDispatch,useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import config from "../../../AppConfig";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

function EventList(props) {
    const isMobile = useMediaQuery('(max-width:600px)');
    const dispatch = useDispatch();
    
    return (
        <>
         <Grid 
                container 
                item 
                lg={12} md={12} sm={12} xs={12} 
                sx={{ display: "flex", justifyContent: "center", marginTop: "4%" }}
                >
                <Grid 
                    container 
                    item 
                    spacing={2} 
                    justifyContent="center"
                >
                    <Grid item xs={12} md={12} lg={12} sm={12}  sx={{ textAlign: "center" }}>
                        <Typography style={{color:"green",fontSize:"26px"}}><b>Upcoming Events</b></Typography>
                    </Grid>
                    <Grid item xs={12} md={6} sx={{ textAlign: "center" }}>
                    <a href={config.BASE_URL + 'nyc-event'}>
                        <img 
                            src={require('../../../assets/images/NYE-Mobile.png')} 
                            style={{ width: isMobile ? "60vw" : "30vw" }} 
                            alt="Image 1" 
                        />
                    </a>
                    </Grid>

                    <Grid item xs={12} md={6} sx={{ textAlign: "center" }}>
                    <a href={config.BASE_URL + 'she-means-business-event'}>
                        <img 
                            src={require('../../../assets/images/she-means-business.png')} 
                            style={{ width: isMobile ? "60vw" : "30vw" }} 
                            alt="Image 2" 
                        />
                    </a>
                    </Grid>
                </Grid>
            </Grid>


        </>
    )
    }

export default EventList;